export default __webpack_public_path__ + "static/media/ill-16.91e29308.svg";